var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0H26V18C26 19.1046 25.1046 20 24 20H4C2.89543 20 2 19.1046 2 18V0Z",
    fill: "url(#paint0_linear_161_12)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 0C0.223858 0 0 0.223858 0 0.5C0 0.776142 0.223858 1 0.5 1H2V18C2 19.1046 2.89543 20 4 20H12.4147L7.29264 25.1473C7.09786 25.3431 7.09863 25.6596 7.29437 25.8544C7.49012 26.0492 7.8067 26.0484 8.00148 25.8527L13.6196 20.2069H14.0275L19.6456 25.8527C19.8404 26.0484 20.1569 26.0492 20.3527 25.8544C20.5484 25.6596 20.5492 25.3431 20.3544 25.1473L15.2323 20H24C25.1046 20 26 19.1046 26 18V1H27.5C27.7761 1 28 0.776142 28 0.5C28 0.223858 27.7761 0 27.5 0H26H25H3H2H0.5ZM25 1H3V18C3 18.5523 3.44772 19 4 19H24C24.5523 19 25 18.5523 25 18V1ZM20.2647 5.96552C20.2647 5.68937 20.0408 5.46552 19.7647 5.46552C19.4886 5.46552 19.2647 5.68937 19.2647 5.96552V14.2414C19.2647 14.5175 19.4886 14.7414 19.7647 14.7414C20.0408 14.7414 20.2647 14.5175 20.2647 14.2414V5.96552ZM14.5 9.27586C14.5 8.99972 14.2761 8.77586 14 8.77586C13.7239 8.77586 13.5 8.99972 13.5 9.27586V14.2414C13.5 14.5175 13.7239 14.7414 14 14.7414C14.2761 14.7414 14.5 14.5175 14.5 14.2414V9.27586ZM8.73529 11.7586C8.73529 11.4825 8.51144 11.2586 8.23529 11.2586C7.95915 11.2586 7.73529 11.4825 7.73529 11.7586V14.2414C7.73529 14.5175 7.95915 14.7414 8.23529 14.7414C8.51144 14.7414 8.73529 14.5175 8.73529 14.2414V11.7586Z",
    fill: "#14B4C2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_161_12",
    x1: 14,
    y1: -15,
    x2: 14,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14B4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14B4C2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSession);
export default __webpack_public_path__ + "static/media/icon-session.2cadbbd3669940652871a5b066d95c63.svg";
export { ForwardRef as ReactComponent };